import { render, staticRenderFns } from "./ModalPreviewStdbQuestion.vue?vue&type=template&id=433d7b27&scoped=true"
import script from "./ModalPreviewStdbQuestion.vue?vue&type=script&lang=js"
export * from "./ModalPreviewStdbQuestion.vue?vue&type=script&lang=js"
import style0 from "./ModalPreviewStdbQuestion.vue?vue&type=style&index=0&id=433d7b27&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "433d7b27",
  null
  
)

export default component.exports